import type { VersionId } from '../../../common/model/index.tsx';
import type { FieldCollection } from '../../model/types.tsx';
import { getRelatedIssueCount } from '../../rest/related-issues/index.tsx';
import { transformRelatedIssueCountsResponse } from './transformers.tsx';

export const getRelatedIssues = (id: VersionId): Promise<FieldCollection> =>
	getRelatedIssueCount(id).then(transformRelatedIssueCountsResponse);
